import { render, staticRenderFns } from "./FullscreenButtonMarginSetting.vue?vue&type=template&id=7c52077f&scoped=true&"
import script from "./FullscreenButtonMarginSetting.vue?vue&type=script&lang=ts&"
export * from "./FullscreenButtonMarginSetting.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenButtonMarginSetting.vue?vue&type=style&index=0&id=7c52077f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52077f",
  null
  
)

export default component.exports